// Shared constants

export const MAX_QUERY_LIMIT = 1000;
export const DEFAULT_QUERY_LIMIT = 50;

/** Default page size for list-view document pagination (infinite scroll). */
export const DOCUMENTS_PAGE_SIZE = DEFAULT_QUERY_LIMIT;

export const SUPPORTED_FILTER_OPERATORS = [
  '<',
  '<=',
  '==',
  '!=',
  '>=',
  '>',
  'array-contains',
  'array-contains-any',
  'in',
  'not-in',
] as const;
